<template>
  <v-dialog v-model="popupcustomer" width="401px" @click:outside="closeNote">
    <v-card class="px-4 py-2 card-note-calender">
      <v-container>
        <v-row class="my-3">
          <v-flex xs6 sm6 md6 lg6 xl6>
            <div>
              <span class="font-24 font-Prompt font-w-600">รายชื่อร้าน</span>
            </div>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6 xl6>
            <div class="float-right">
              <span class="font-16 text-gary-date">จำนวน : {{ shopLenght }} ร้าน</span>
            </div>
          </v-flex>
        </v-row>
        <v-row>
          <vue-scroll :ops="ops" ref="vs">
            <div class="list-height">
              <v-flex v-for="(customer, index) in shopList" :key="index">
                <v-row class="mt-5 mb-1 px-3">
                  <v-flex xs4 sm2 md3 lg3 xl2>
                    <div class="py-3">
                      <v-avatar>
                        <img :src="customer.customer_pic" alt="John" />
                      </v-avatar>
                    </div>
                  </v-flex>
                  <v-flex xs8 sm10 md9 lg19 xl10>
                    <v-row>
                      <v-flex xs12 sm12 md12 lg12 xl12>
                        <div class="my-1">
                          <span class="font-16 font-w-600">
                            {{ customer.customer_name || customer.company_name }}
                          </span>
                        </div>
                        <div class="my-1">
                          <v-icon class="icon-font-30">icon-SITE_COST</v-icon>
                          <span class="font-16 text-red-d font-w-600 mx-1 my-1">ร้านค้าช่วง</span>
                          <v-icon class="icon-font-30 icon-text-blue ml-3">icon-Pin</v-icon>
                          <span class="font-16 font-w-400 text-blue ml-1">
                            {{ customer.distance | toTwoDigit }}
                          </span>
                        </div>
                      </v-flex>
                    </v-row>
                  </v-flex>
                </v-row>
                <v-divider></v-divider>
              </v-flex>
            </div>
          </vue-scroll>
        </v-row>
        <!-- <v-row class="my-3">
          <v-flex xs6 sm6 md6 lg6 xl6>
            <div>
              <span class="font-24 font-Prompt font-w-600">รายชื่อร้าน</span>
            </div>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6 xl6>
            <div class="float-right">
              <span class="font-16 text-gary-date">จำนวน : 4 ร้าน</span>
            </div>
          </v-flex>
        </v-row>
        <v-row class="mt-5 mb-1">
          <v-flex xs4 sm2 md3 lg3 xl2>
            <div class="py-3">
              <v-avatar>
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
              </v-avatar>
            </div>
          </v-flex>
          <v-flex xs8 sm10 md9 lg19 xl10>
            <v-row>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <div class="my-1">
                  <span class="font-16 font-w-600">ร้าน SmartSmart รุ่งเรืองอำไพ</span>
                </div>
                <div class="my-1">
                  <v-icon class="icon-font-30">icon-SITE_COST</v-icon>
                  <span class="font-16 text-red-d font-w-600 mx-1 my-1">ร้านค้าช่วง</span>
                  <v-icon class="icon-font-30 icon-text-blue ml-3">icon-Pin</v-icon>
                  <span class="font-16 font-w-400 text-blue ml-1">24km.</span>
                </div>
              </v-flex>
            </v-row>
          </v-flex>
        </v-row>
        <v-divider></v-divider>
        <v-row class="my-1">
          <v-flex xs4 sm2 md3 lg3 xl2>
            <div class="py-3">
              <v-avatar>
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
              </v-avatar>
            </div>
          </v-flex>
          <v-flex xs8 sm10 md9 lg19 xl10>
            <v-row>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <div class="my-1">
                  <span class="font-16 font-w-600">ร้าน SmartSmart รุ่งเรืองอำไพ</span>
                </div>
                <div class="my-1">
                  <v-icon class="icon-font-30">icon-SITE_COST</v-icon>
                  <span class="font-16 text-red-d font-w-600 mx-1 my-1">ร้านค้าช่วง</span>
                  <v-icon class="icon-font-30 icon-text-blue ml-3">icon-Pin</v-icon>
                  <span class="font-16 font-w-400 text-blue ml-1">24km.</span>
                </div>
              </v-flex>
            </v-row>
          </v-flex>
        </v-row>
        <v-divider></v-divider>
        <v-row class="my-1">
          <v-flex xs4 sm2 md3 lg3 xl2>
            <div class="py-3">
              <v-avatar>
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
              </v-avatar>
            </div>
          </v-flex>
          <v-flex xs8 sm10 md9 lg19 xl10>
            <v-row>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <div class="my-1">
                  <span class="font-16 font-w-600">ร้าน SmartSmart รุ่งเรืองอำไพ</span>
                </div>
                <div class="my-1">
                  <v-icon class="icon-font-30">icon-SITE_COST</v-icon>
                  <span class="font-16 text-red-d font-w-600 mx-1 my-1">ร้านค้าช่วง</span>
                  <v-icon class="icon-font-30 icon-text-blue ml-3">icon-Pin</v-icon>
                  <span class="font-16 font-w-400 text-blue ml-1">24km.</span>
                </div>
              </v-flex>
            </v-row>
          </v-flex>
        </v-row>
        <v-divider></v-divider> -->

        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-btn class="btn-save font-20 font-Prompt my-2" @click="closeNote">รับทราบ</v-btn>
        </v-flex>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    active: false,
    date: String,
    customerList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dialog: false,
      calendarlistday: false,
      shopList: [],
      ops: {
        maxHeight: 330,
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'percent',
          detectResize: true
        },
        scrollPanel: {
          scrollingX: false
        },

        bar: {
          background: 'rgba(0, 0, 0, 0.87)',
          keepShow: false,
          size: '5px',
          minSize: 0.2
        }
      }
    }
  },
  computed: {
    popupcustomer: {
      get() {
        return this.active
      },
      set() {
        this.dialog = this.active
      }
    },
    getDate() {
      return this.date
    },
    shopLenght() {
      return this.shopList ? this.shopList.length : 0
    }
  },
  watch: {
    date: function(newVal, oldVal) {
      this.getShopList(newVal)
    }
  },
  methods: {
    getShopList(date) {
      this.shopList = []
      const paramUser = this.$route.query.userId
      let userId
      if (paramUser) {
        userId = paramUser
      } else {
        userId = 2
      }
      const formData = new FormData()
      formData.append('user_id', userId)
      formData.append('date', date)
      fetch(`${this.$baseAPINew}/web/?act=customer_list_inday`, {
        method: 'POST',
        body: formData
      })
        .then((response) => response.json())
        .then((result) => (this.shopList = result))
        .catch((error) => {})
    },
    closeNote() {
      if (this.popupcustomer) {
        this.dialog = false
        this.$emit('closenote', false)
      }
    }
  }
}
</script>

<style>
.list-height {
  height: 320px;
}
</style>
